module.exports = __webpack_public_path__ + "img/二维码_阳江.a31f2c46.png";